import { trace } from 'rytm-helpers'

const CONTACT_LOADER_CLASS_NAME = "contact-loader"

export const initContactLoader = () => {
  document.addEventListener("click", onDocClick)
}
const onDocClick = (e) => {
  if (e.target.classList.contains(CONTACT_LOADER_CLASS_NAME)) {
    e.preventDefault()
    const url = e.target.dataset.url
    if (url && !document.documentElement.classList.contains("content-loading")) {
      document.documentElement.classList.add("content-loading")
      loadEmail(url, e.target)
    }
    
  }
}

const loadEmail = (url, link) => {
  // make ajax request to fetch email
  let xhr = new XMLHttpRequest()
  xhr.currentLink = link
  // add event listeners
  xhr.addEventListener('loadstart', onXhrLoadStart);
  xhr.addEventListener('load', onXhrLoad);
  xhr.addEventListener('loadend', onXhrLoadEnd);
  xhr.addEventListener('progress', onXhrProgress);
  xhr.addEventListener('error', onXhrError);
  xhr.addEventListener('abort', onXhrAbord);
  xhr.open('GET', url)
  xhr.send()
}
/**
 * ######################
 * # XHR Event handlers #
 */
// # XHR Start
const onXhrLoadStart = (e) => {
  // dispatch event
  document.documentElement.classList.add("content-loading")
}
// # XHR Load
const onXhrLoad = (e) => {
  // 
}
// # XHR Complete
const onXhrLoadEnd = (e) => {
  if (e.target.responseText) {
    // invoke email link
    // const emailLink = document.createElement("a")
    const emailLink = e.target.currentLink
    // set target _blank
    emailLink.target = "_blank"
    emailLink.classList.remove(CONTACT_LOADER_CLASS_NAME)
    emailLink.href = "mailto:" + e.target.responseText
    emailLink.click()
    // remove loading class
    document.documentElement.classList.remove("content-loading")
  }
}
// # XHR Progress
const onXhrProgress = (e) => {
  // console.log("progress", e)
}
// # XHR Error
const onXhrError = (e) => {
  document.documentElement.classList.remove("content-loading")
}
// # XHR Abord
const onXhrAbord = (e) => {
  document.documentElement.classList.remove("content-loading")
}